import { render } from "./inputFile.vue?vue&type=template&id=b4f5b940"
import script from "./inputFile.vue?vue&type=script&lang=js"
export * from "./inputFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__